import axios from 'axios'
import { returUrl, getHeader } from '@/config'

const state = {
  returList: [{
    id: null,
    type: null,
    return_no: null,
    return_date: null,
    deliver_date: null,
    vendor_no: null,
    purchasing_no: null,
    sale_no: null,
    notes: null,
    status: null,
    branch_no: null,
    company_no: null,
    lock: false,
    is_deliver: null,
    customer_no: null,
    subtotal: '0',
    discount: '0',
    discount_percentage: '0',
    tax_id: null,
    tax: '0',
    total: '0',
    salesman_id: null,
    category: null,
    ref_no: null
  }],
  return: {
    id: null,
    name: null,
    customer: null,
    vendor: null,
    details: [{
      id: null,
      return_no: null,
      product_no: null,
      product_sku: null,
      serial_number: null,
      uom_id: null,
      qty: '0',
      amount: '0',
      notes: null,
      warehouse_no: null,
      branch_no: null,
      company_no: null,
      discount: '0',
      discount_percentage: '0',
      tax_id: null,
      tax: '0',
      total: '0',
      return_date: null,
      cost: '0',
      cost_id: null,
      penalty_amount: '0',
      subtotal: '0'
    }]
  }
}

const mutations = {
  SET_RETUR_LIST (state, obj) {
    state.returList = obj
  },
  SET_RETURN_BY_NO (state, obj) {
    state.return = obj
  }
}

const actions = {
  getReturList: ({ commit }, payload) => {
    let url = null
    if (typeof payload === 'undefined') {
      url = returUrl
    } else {
      url = returUrl + payload
    }
    axios.get(url, { headers: getHeader() })
      .then(response => {
        commit('SET_RETUR_LIST', response.data.data)
      })
  },
  getReturnByNo: ({ commit }, payload) => {
    axios.post(returUrl + '/get-return-no', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_RETURN_BY_NO', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
